import script from "./CapitalFlow.vue?vue&type=script&setup=true&lang=js"
export * from "./CapitalFlow.vue?vue&type=script&setup=true&lang=js"

import "./CapitalFlow.vue?vue&type=style&index=0&id=7f4695bc&lang=css"

const __exports__ = script;

export default __exports__